










import { Vue, Component } from 'vue-property-decorator';
import Swiper from 'swiper';
@Component
export default class WebSwiper extends Vue {
  public swiper!: Swiper;
  mounted() {
    this.swiper = new Swiper('#web-swiper', {
      direction: 'vertical',
      keyboard: {
        enabled: true,
      },
      mousewheel: true,
    });
  };
}
